<template>
    <v-container>
        <div id="vis-container">
            <svg class="svg-frame" width="780" height="480"></svg>
        </div>
    </v-container>
</template>

<script>

import * as d3Base from 'd3';
import * as d3Collection from 'd3-collection';
import _ from 'lodash';
import * as d3Dag from 'd3-dag';

export default {
    data() {
        return {
            d3: null,
            nodeSize: "Constant Separation",
            source: "Grafo",
            spline: 0,
            arrows: true,
            nodeRadius: 20,
            computedDag : null,
            env: {
                width: 1600, 
                height: 1600, 
                maxHeight: 1600, 
                lineMaxHeight: 16,
                maxLineHeight: 40,
                minLabelFont: 16,
                margin: { top: 26, right: 0, bottom: 30, left: 150 },
                groupBkgGradient: ['#FAFAFA', '#E0E0E0'],
                xScale: null,
                yScale: null,
                grpScale:null,
                xGrid: null,
                yAxis:null,
                xAxis: null,
                grpAxis: null,
                category: "group",
                svg: null,
                graph: null,
                graphW: null,
                graphH: null,
                nLines: 0,
                minSegmentDuration: 0,
                transDuration: 700,
                structData: null,
                flatData: null,
                g: null,
                labels: [],
                border:1,
                lineHeight:0,
                xt:null,
                color:[],
                colorScale:null,
                clip:null,
                group: null
            },
            colors: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f","#bf5b17","#666666"],
            colorsBU: ["#95A5A6", "#85C1E9", "#F4D03F", "#D2B4DE", "#EDBB99", "#73C6B6", "#EDBB99", "#D5DBDB", "#FEF9E7", "#EBDEF0"],
        }
    },
    mounted() {
        this.$nextTick(function () {
        

        this.d3 = Object.assign({}, d3Base, d3Dag);

        console.log(this.d3)
         this.xScale = this.d3.scaleTime();
                this.yScale = this.d3.scalePoint();
                this.grpScale = this.d3.scaleOrdinal();
                this.xGrid = this.d3.axisTop();
                this.yAxis = this.d3.axisRight();
                this.xAxis = this.d3.axisBottom();
                this.grpAxis = this.d3.axisLeft();

  var arrayData =  [
                {
                "id": "C001",
                "description": "Appropriations and Staffing",
                "start": "1982-03-25",
                "finish": "2015-03-24",
                "group": "Domestic",
                "parentIds": [],
                },
                {
                "id": "C002",
                "description": "Appropriations, Staffing and Security",
                "start": "2015-03-25",
                "finish": "2022-10-06",
                "group": "Domestic",
                "parentIds": ["C001"]
                },
                {
                "id": "C003",
                "description": "Elections and Qualifications",
                "start": "1901-06-06",
                "finish": "1903-09-02",
                "group": "Domestic",
                "parentIds": []
                },
                {
                "id": "C004",
                "description": "Disputed Returns and Qualifications",
                "start": "1903-09-03",
                "finish": "1987-09-22",
                "group": "Domestic",
                "parentIds": ["C003"]
                },
                {
                "id": "C005",
                "description": "House",
                "start": "1901-06-06",
                "finish": "2022-10-06",
                "group": "Domestic",
                "parentIds": []
                },
                {
                "id": "C006",
                "description": "Library",
                "start": "1901-06-06",
                "finish": "2022-10-06",
                "group": "Domestic",
                "parentIds": []
                },
                {
                "id": "C007",
                "description": "Printing",
                "start": "1901-06-06",
                "finish": "1970-06-11",
                "group": "Domestic",
                "parentIds": []
                },
                {
                "id": "C008",
                "description": "Publications",
                "start": "1970-06-12",
                "finish": "2022-10-06",
                "group": "Domestic",
                "parentIds": ["C007"]
                },
                {
                "id": "C009",
                "description": "Standing Orders",
                "start": "1901-06-05",
                "finish": "1987-09-21",
                "group": "Domestic",
                "parentIds": []
                },
                {
                "id": "C010",
                "description": "Procedure",
                "start": "1987-09-22",
                "finish": "2022-10-06",
                "group": "Domestic",
                "parentIds": ["C009"]
                },
                {
                "id": "C011",
                "description": "Selection of Bills",
                "start": "1989-12-05",
                "finish": "2022-10-06",
                "group": "Domestic",
                "parentIds": []
                },
                {
                "id": "C012",
                "description": "Senators’ Interests",
                "start": "1994-03-17",
                "finish": "2022-10-06",
                "group": "Domestic",
                "parentIds": []
                },
                {
                "id": "C013",
                "description": "Privileges",
                "start": "1965-02-02",
                "finish": "2022-10-06",
                "group": "Domestic",
                "parentIds": []
                },
                {
                "id": "C014",
                "description": "Regulations and Ordinances",
                "start": "1932-03-11",
                "finish": "2019-12-03",
                "group": "Legislative scrutiny",
                "parentIds": []
                },
                {
                "id": "C015",
                "description": "Scrutiny of Bills",
                "start": "1981-11-19",
                "finish": "2022-10-06",
                "group": "Legislative scrutiny",
                "parentIds": []
                },
                {
                "id": "C016",
                "description": "Social Environment",
                "start": "1970-06-11",
                "finish": "1975-11-11",
                "group": "Legislative and General Purpose Standing",
                "parentIds": []
                },
                {
                "id": "C017",
                "description": "Health and Welfare",
                "start": "1970-06-11",
                "finish": "1975-11-11",
                "group": "Legislative and General Purpose Standing",
                "parentIds": []
                },
                {
                "id": "C018",
                "description": "Social Welfare",
                "start": "1976-03-02",
                "finish": "1987-06-05",
                "group": "Legislative and General Purpose Standing",
                "parentIds": ["C017"]
                },
                {
                "id": "C019",
                "description": "Community Affairs",
                "start": "1987-09-22",
                "finish": "1994-10-09",
                "group": "Legislative and General Purpose Standing",
                "parentIds": ["C018"]
                },
                {
                "id": "C020",
                "description": "Community Affairs",
                "start": "1994-10-10",
                "finish": "2006-09-10",
                "group": "Legislation",
                "parentIds": ["C019"]
                },
                {
                "id": "C021",
                "description": "Community Affairs",
                "start": "1994-10-10",
                "finish": "2006-09-10",
                "group": "References",
                "parentIds": ["C019"]
                },
                {
                "id": "C022",
                "description": "Community Affairs",
                "start": "2006-09-11",
                "finish": "2009-05-13",
                "group": "Legislative and General Purpose Standing",
                "parentIds": ["C020","C021"]
                },
                {
                "id": "C023",
                "description": "Community Affairs",
                "start": "2009-05-14",
                "finish": "2022-10-06",
                "group": "Legislation",
                "parentIds": ["C022"]
                },
                {
                "id": "C024",
                "description": "Community Affairs",
                "start": "2009-05-14",
                "finish": "2022-10-06",
                "group": "References",
                "parentIds": ["C022"]
                },
                {
                "id": "C025",
                "description": "Economics",
                "start": "1994-10-10",
                "finish": "2006-09-10",
                "group": "Legislation",
                "parentIds": []
                },
                {
                "id": "C026",
                "description": "Economics",
                "start": "1994-10-10",
                "finish": "2006-09-10",
                "group": "References",
                "parentIds": []
                },
                {
                "id": "C027",
                "description": "Economics",
                "start": "2006-09-11",
                "finish": "2009-05-13",
                "group": "Legislative and General Purpose Standing",
                "parentIds": ["C025","C026"]
                },
                {
                "id": "C028",
                "description": "Economics",
                "start": "2009-05-14",
                "finish": "2022-10-06",
                "group": "Legislation",
                "parentIds": ["C027"]
                },
                {
                "id": "C029",
                "description": "Economics",
                "start": "2009-05-14",
                "finish": "2022-10-06",
                "group": "References",
                "parentIds": ["C027"]
                }
            ];

            var reader = this.d3.dagStratify();

            var dag3 = reader(arrayData);


            //var dag3 = this.d3.dagStratify()(arrayData);
     

            const layout = this.d3
                .sugiyama()
                .layering(this.d3.layeringCoffmanGraham())
                .decross(this.d3.decrossTwoLayer().order(this.d3.twolayerGreedy().base(this.d3.twolayerAgg())))
                .coord(this.d3.coordSimplex())
                .nodeSize(this.nodeSizes.find(i => i == this.nodeSize))(this.dag);

            const start = performance.now();
            const { width, height } = layout;
            const time = performance.now() - start;
       

            console.log(dag3)
  

        // // This code only handles rendering
        // const svgNode = svg`<svg width=${width} height=${height}></svg>`;
        const svgSelection = this.d3.select("svg.svg-frame");
        const defs = svgSelection.append("defs"); // For gradients

        // Initialize color map
        const steps = dag3.size();
        const interp = this.d3.interpolateRainbow;
        const colorMap = {};
        for (const [i, node] of [...dag3].entries()) {
            colorMap[node.data.id] = interp(i / steps);
        }
var links = dag3.links();
        var descendants = dag3.descendants();
       console.log(descendants)
        // How to draw edges
 
    
        const line = this.d3
            .line()
            .curve(this.d3.curveCatmullRom)
            .x((d) => d.x)
            .y((d) => d.y);
 
        // Plot edges
        svgSelection
            .append("g")
            .selectAll("path")
            .data(dag3.links())
            .enter()
            .append("path")
            .attr("d", ({ points }) => line(points))
            .attr("fill", "none")
            .attr("stroke-width", 3)
            .attr("stroke", ({ source, target }) => {

                console.log(source)
                // encodeURIComponents for spaces, hope id doesn't have a `--` in it
                const gradId = encodeURIComponent(`${source.data.id}--${target.data.id}`);
                const grad = defs
                    .append("linearGradient")
                    .attr("id", gradId)
                    .attr("gradientUnits", "userSpaceOnUse")
                    .attr("x1", source.x)
                    .attr("x2", target.x)
                    .attr("y1", source.y)
                    .attr("y2", target.y);
                grad
                    .append("stop")
                    .attr("offset", "0%")
                    .attr("stop-color", colorMap[source.data.id]);
                grad
                    .append("stop")
                    .attr("offset", "100%")
                    .attr("stop-color", colorMap[target.data.id]);
                return `url(#${gradId})`;
            });

        // Select nodes
        const nodes = svgSelection
            .append("g")
            .selectAll("g")
            .data(dag3.descendants())
            .enter()
            .append("g")
            .attr("transform", ({ x, y }) => `translate(${x}, ${y})`);

        // Plot node circles
        nodes.append("circle")
            .attr("r", this.nodeRadius)
            .attr("fill", (n) => colorMap[n.data.id]);

            // Plot Arrows
            if (this.arrows) {
                const arrowSize = (this.nodeRadius * this.nodeRadius) / 5.0;
                const arrowLen = Math.sqrt((4 * arrowSize) / Math.sqrt(3));
                const arrow = this.d3.symbol().type(this.d3.symbolTriangle).size(arrowSize);
                svgSelection
                .append("g")
                .selectAll("path")
                .data(dag3.links())
                .enter()
                .append("path")
                .attr("d", arrow)
                .attr("transform", ({ source, target, points }) => {
                    const [end, start] = points.slice().reverse();
                    const dx = start.x - end.x;
                    const dy = start.y - end.y;
                    const scale = (this.nodeRadius * 1.15) / Math.sqrt(dx * dx + dy * dy);
                    // This is the angle of the last line segment
                    const angle = (Math.atan2(-dy, -dx) * 180) / Math.PI + 90;
                    console.log(angle, dx, dy);
                    return `translate(${end.x + dx * scale}, ${
                    end.y + dy * scale
                    }) rotate(${angle})`;
                })
                .attr("fill", ({ target }) => colorMap[target.data.id])
                .attr("stroke", "white")
                .attr("stroke-width", 1.5)
                .attr("stroke-dasharray", `${arrowLen},${arrowLen}`);
            }

        // Add text to nodes
        nodes.append("text")
            .text((d) => d.data.id)
            .attr("font-weight", "bold")
            .attr("font-family", "sans-serif")
            .attr("text-anchor", "middle")
            .attr("alignment-baseline", "middle")
            .attr("fill", "white");
        });
    },
    methods: {
        parseTime() {
            this.d3.timeParse("%dd/%m/%Y");
        },
        zoom(){

            this.d3.zoom()
                .scaleExtent([0.5, 32])
                .on("zoom", this.redraw());
        },
        invertOrdinal(val, cmpFunc) {
            cmpFunc = cmpFunc || function (a, b) {
                return (a >= b);
            };

            const scDomain = this.domain();
            let scRange = this.range();

            if (scRange.length === 2 && scDomain.length !== 2) {
                // Special case, interpolate range vals
                scRange = this.d3.range(scRange[0], scRange[1], (scRange[1] - scRange[0]) / scDomain.length);
            }

            const bias = scRange[0];
            for (let i = 0, len = scRange.length; i < len; i++) {
                if (cmpFunc(scRange[i] + bias, val)) {
                    return scDomain[Math.round(i * scDomain.length / scRange.length)];
                }
            }

            return this.domain()[this.domain().length - 1];
        },
        convertdata() {
            for (var t = 0; t < this.env.structData.length; t++) {
                this.env.structData[t].start = new Date(this.env.structData[t].start)
                this.env.structData[t].finish = new Date(this.env.structData[t].finish)
                this.env.structData[t].id = this.env.structData[t].id
                this.env.structData[t].prevLink = this.env.structData[t].prevLink
            }
        },
        getColor() {           
            this.env.structData.forEach(function (item) {
                this.env.color.push(item.label)
            })
            this.env.color = this.env.color.filter((v, i, a) => a.indexOf(v) === i);
            return this.env.color
        },
        getlabels() {            
            this.env.labels= [];
            this.env.structData.forEach(function (item) {
                this.env.labels.push(item.sub)
            })
            this.env.labels = this.env.labels.filter((v, i, a) => a.indexOf(v) === i);
            this.env.labels.sort()
            return this.env.labels
        },
        getLines() {
            this.env.nLines = 0
            this.env.flatData.forEach(function (item) {
                this.env.nLines += item.count
            })
            return this.env.nLines
        },
        resolveOverlaps() {
            for (var t = 0; t < this.env.structData.length; t++) {
                //this.env.structData[t].line = null  
                this.env.structData[t].sub = null  

            }

            this.env.flatData = []

            this.env.structData.sort(function (a, b) {
                return this.d3.ascending(a.start, b.start);
            });

            var keys = this.env.structData.map(function (d) { return d[this.env.category]; })
                .reduce(function (p, v) { return p.indexOf(v) == -1 ? p.concat(v) : p; }, [])
                .filter(function (d) { return (typeof d !== "undefined") ? d !== null : false });

            keys.forEach(function (key) {
                var items = this.env.structData.filter(function (d) { return d[this.env.category] === key; });
                var i, line, count = [], lines = [];

                var top = this.d3.max(this.env.structData, function (d) { return d.line }) || 0;        
              
                items.forEach(function (item) {                  
                    for (i = 0, line = 0; i < top; i++ , line++) {  
                   
                        if (item.finish <= lines[i]) { break; }
                    }
               
               //item.line = item.line;           
                    item.sub = item[this.env.category] + '+&+' + item.line
                    lines[line] = item.start;
                    count.push(item.line);
                })
          
                this.env.flatData.push({ category: items[0][this.env.category], count: count.length })
            });
           
            this.env.flatData.sort(function (a, b) {
                return this.d3.ascending(a.category, b.category);
            });
        },
        update_group(){
            var test = [];
            this.env.group = this.env.g.selectAll(".rectangle")
                .data(this.env.structData)
                .join(function (group) {
                var outerG = group.append("g");
                var rectItem = outerG.attr("class", "rectangle");
                
                group.each(function(d,i) { 
                
                    d.parentIds.forEach(function (linkId) {
            
                    test.push("p-" + d.id + "-"+ linkId);
                    });
                })
                var denter = rectItem.append("svg").attr("class", function (d) { return "svgholder " + d.id; });
                denter.append("rect").attr("class", function (d) { 
                
                    return "rectband " + d.id; });
                denter.append("text").attr("class", function (d) { return "interval " + d.id; });
                denter.append("rect").attr("class", function (d) { return "lefthand clasl " + d.id; });
                denter.append("rect").attr("class", function (d) { return "righthand clasr " + d.id; });
                return denter;                     
                },
            );
            
                test.forEach(function (link) {
                    this.env.g.append("path").attr("class", "path").attr("pathId", link).attr("d", "").attr("marker-end",    "").attr("stroke", "").attr("fill", "");
                    
                    });
            
            return this.env.group;
        },
        draw(event, d) {                                          
                // console.log("in")
                if (event) {
                        var t = event.transform
                        this.env.xt = t.rescaleX(this.env.xScale);
                    } else {
                        this.env.xt = this.env.xScale;
                    }
                
                    this.env.color = this.getColor()
                    this.env.colorScale = this.d3.scaleOrdinal(this.colors).domain(this.env.color)
                    this.env.lineHeight = this.env.graphH / this.env.nLines * 0.8;

                    this.env.svg.select('.x-grid').call(this.env.xGrid.scale(this.env.xt));   
                const tr = this.env.svg.transition()
                        .duration(750);
                this.update_group()


                    this.env.g.selectAll(".rectangle")
                        .attr("width", function (d) { 
                    // console.log(d)
                    return this.env.xt(d.finish) - this.env.xt(d.start) })
                        .attr("height", this.env.lineHeight)
                        .attr("fill", function (d, i) { return this.env.colorScale(d.description); })               
                        .attr("transform", function (d) {
                        // console.log(d)
                            return "translate(" + this.env.xt(d.start) + "," + (d.line - this.env.lineHeight / 2) + ")";
                        })
                        .attr("xC", function (d) { return this.env.xt(d.start); })
                        .attr("yC", function (d) { return (d.line - this.env.lineHeight / 2); })
                        .attr("id", function (d) { return d.id; })
                    .attr("line", function (d) { return d.line; })
                    .attr("link", function (d) { return d.parentIds.join(','); })
                        ;


                    this.env.group.selectAll(".svgholder")
                        .attr("width", function (d) { return this.env.xt(d.finish) - this.env.xt(d.start) })            
                        .attr("height", this.env.lineHeight);
        
                

                    this.env.group.selectAll(".rectband")
                        .attr("width", function (d) { return this.env.xt(d.finish) - this.env.xt(d.start) })
                        .attr("height", this.env.lineHeight)
                        .style("opacity", .5) // set the element opacity
                        .style("stroke", "black");

                

                    this.env.group.selectAll(".interval")
                        .attr("x", 6)
                        .attr("y", 9)
                        .style("pointer-events", "none")
                        .style("fill", "black")
                        .attr("font-size", 11)
                        .attr("font-family", "Cambria")
                        .text(function (d) { return (d.id + ": " + d.description); });


                    this.env.group.selectAll(".lefthand")          
                        .attr("idx", function (d) { return d.id; })
                        .attr("start", function (d) { return d.start; })
                        .attr("height", this.env.lineHeight)
                
                        .attr("width", 2)
                        .attr("fill", "#4A235A")
                        .attr("fill-opacity", 1)
        

                this.env.group.selectAll(".righthand")
                        .attr("x", function (d) { return this.env.xt(d.finish) - this.env.xt(d.start) - 2 })                       
                        .attr("idx", function (d) { return d.id; })
                        .attr("start", function (d) { return d.start; })
                        .attr("height", this.env.lineHeight)

                        .attr("width", 2)
                        .attr("fill", "#4A235A")
                        .attr("fill-opacity", 1)
                        ;        
                
            this.drawLinks();
        },
        drawLinks(event, d) {      
            this.env.g.selectAll(".rectangle").each(function(d,i) {
                if (this.d3.select(this).attr("link") !== ''){

                var linkFrom = this.d3.select(this);
            
                var linkNum = this.d3.select(this).attr("link");
                var linkId = this.d3.select(this).attr("id");
            var splitLink = linkNum.split(',');

                splitLink.forEach(function (linkNumInner) {
                    
                    var linkTo = this.d3.select('.rectangle[id="' + linkNumInner + '"]');

            console.log(linkTo.data());
            if (linkTo != null && linkTo._groups != null && linkTo._groups[0][0] !== null){


                var path = this.d3.select('.path[pathId="p-' + linkId + '-' + linkNumInner + '"]');
            

                const linkSource = {
                    x: linkFrom.attr('xC'),
                    y: parseFloat(linkFrom.attr('yC')) + this.env.lineHeight/2
                };

                const linkTarget = {
                    x: parseFloat(parseFloat(linkTo.attr('xC')) + parseFloat(linkTo.attr('width'))),
                    y: parseFloat(linkTo.attr('yC')) + this.env.lineHeight/2
                };

                const link = this.d3
                    .linkHorizontal()
                    .x(d => d.x)
                    .y(d => d.y)({
                    source: linkSource,
                    target: linkTarget
                });

            //  console.log(path)

                path
                .attr('d', link)
                .attr('marker-end', 'url(#arrow)')
                .attr('stroke', 'black')
                    .attr('stroke-width', '4')
                .attr('fill', 'none');
                }
                
                });
                
                }
            });
        },
        redraw(event, d) {
            
                this.env.svg.select('.x-grid').call(this.env.xGrid.scale(this.env.xt));

                this.env.color = this.getColor()
                this.env.colorScale = this.d3.scaleOrdinal(this.colors).domain(this.env.color)
                this.env.lineHeight = this.env.graphH / this.env.nLines * 0.8;

                if (event) {
                
                    var t = event.transform
                    this.env.xt = t.rescaleX(this.env.xScale);
                } else {
                    this.env.xt = this.env.xScale;
                }
            
        
                this.d3.selectAll(".rectangle")          
                    .data(this.env.structData)         
                    .attr("width", function (d) { return this.env.xt(d.finish) - this.env.xt(d.start) })
                    .attr("height", this.env.lineHeight)
                    .attr("fill", function (d, i) { return this.env.colorScale(d.description); })
                    .attr("xC", function (d) { return this.env.xt(d.start); })
                    .attr("yC", function (d) { return (d.line - this.env.lineHeight / 2); })
                    .attr("transform", function (d) {return "translate(" + this.env.xt(d.start) + "," + (d.line - this.env.lineHeight / 2) + ")";});
                
                this.d3.selectAll(".svgholder")
                    .attr("height", this.env.lineHeight)
                    .attr("width", function (d) { return this.env.xt(d.finish) - this.env.xt(d.start) });
                
                this.d3.selectAll(".rectband")
                    .data(this.env.structData)
                    .attr("width", function (d) { return (this.env.xt(d.finish) - this.env.xt(d.start)) })
                    .attr("height", this.env.lineHeight)
                    .attr("fill", function (d, i) { return this.env.colorScale(d.description); })
                    .attr("x", 0)
                    .attr("y", 0);
                    

                this.d3.selectAll(".interval")
                    .attr("x", 6)
                    .attr("y", 9)
                    .style("pointer-events", "none")
                    .style("fill", "black")
                    .attr("font-size", 11)
                    .attr("font-family", "Cambria")
                    .text(function (d) { return (d.id + ": " + d.description); });


                this.d3.selectAll(".lefthand")           
                    .attr("width", 2)
                    .attr("height", this.env.lineHeight)
                    .attr("fill", "#4A235A");

                
                this.d3.selectAll(".righthand")  
                    .attr("x", function (d) { return this.env.xt(d.finish) - this.env.xt(d.start) - 2 })   
                    .attr("width", 2)
                    .attr("height", this.env.lineHeight)
                    .attr("fill", "#4A235A");

            this.drawLinks();
        },
        parseData(data) {            
            this.convertdata()
            this.resolveOverlaps()
            for (var t = 0; t < this.env.structData.length; t++) {
                this.env.structData[t].order = t + 1
            }
   
            this.env.structData.sort(function (a, b) {
                return this.d3.ascending(a.order, b.order);
            });

            this.env.labels = this.getlabels()
            this.env.nLines = this.getLines();
            this.env.graphW = this.env.width - this.env.margin.left - this.env.margin.right;
            this.env.graphH = this.d3.min([this.env.nLines * this.env.maxLineHeight, this.env.maxHeight - this.env.margin.top - this.env.margin.bottom]);
            this.env.g.attr("clip-path", "url(#clip)");
        },
        buildDomStructure() {

            this.env.graphW = this.env.width - this.env.margin.left - this.env.margin.right;

            this.env.xScale.range([0, this.env.graphW])

            this.env.svg.attr("width", this.env.width);

            var axises = this.env.svg.append('g');

            this.env.graph.attr("transform", "translate(" + this.env.margin.left + "," + this.env.margin.top + ")");

            this.env.g.attr("transform", "translate(" + this.env.margin.left + "," + this.env.margin.top + ")");

            axises.attr("class", "axises")
                .attr("transform", "translate(" + this.env.margin.left + "," + this.env.margin.top + ")");

            axises.append("g")
                .attr("class", "x-axis");

            axises.append("g")
                .attr("class", "x-grid");

            axises.append("g")
                .attr("class", "y-axis")
                .attr("transform", "translate(" + this.env.graphW + ", 0)");

            axises.append("g")
                .attr("class", "grp-axis");

            this.env.xAxis.scale(this.env.xScale)
                .ticks(Math.round(this.env.graphW * 0.011));

            this.env.xGrid.scale(this.env.xScale)
                .tickFormat("")
                .ticks(this.env.xAxis.ticks()[0]);

            this.env.yAxis.scale(this.env.yScale)
                .tickSize(0);

            this.env.grpAxis.scale(this.env.grpScale)
                .tickSize(0);

        },
        renderAxises() {

            this.env.height = this.env.graphH + this.env.margin.top + this.env.margin.bottom
          
            this.env.svg.transition().duration(100).attr('width', this.env.width).attr('height', this.env.height);

            this.env.g.attr("transform", "translate(" + this.env.margin.left + "," + this.env.margin.top + ")");

            var fontVerticalMargin = 0.6;

            var fontSize = Math.min(12, this.env.graphH / this.env.flatData.length * fontVerticalMargin * Math.sqrt(2));
                  
            this.env.yScale            
                .domain(this.env.labels)
                .range([this.env.graphH / this.env.labels.length * 0.5, this.env.graphH * (1 - 0.5 / this.env.labels.length)]);

            this.env.yScale.invert = this.invertOrdinal;
            this.env.grpScale.invert = this.invertOrdinal;

            this.env.xGrid
                .scale(this.env.xScale)
                .tickSize(this.env.graphH)
                .tickFormat(this.d3.timeFormat("%b %Y"));
          
            this.env.xScale
                .domain([this.d3.min(this.env.structData, function (d) { return d.start; }), this.d3.max(this.env.structData, function (d) { return d.finish; })])
                .range([0, this.env.graphW]);


            this.env.svg.select('g.x-grid')
                .attr('transform', 'translate(0,' + this.env.graphH + ')')
                .transition().duration(100)
                .call(this.env.xGrid);


            var groups = this.env.graph.selectAll('rect.series-group, g.series-group ').data(this.env.flatData, function (d) {
                return d.category;
            });

            this.env.yAxis.tickValues("");   //labels

            this.env.svg.select('g.y-axis')
                .transition().duration(100)
                .attr('transform', 'translate(' + this.env.graphW + ', 0)')
                .style('font-size', fontSize + 'px')
                .call(this.env.yAxis);

            var minHeight = this.d3.min(this.env.grpScale.range(), function (d, i) {
                return i > 0 ? d - this.env.grpScale.range()[i - 1] : d * 2;
            });

            this.env.grpAxis.tickFormat(function (d) { return d })
                .ticks(0);

            this.env.grpScale.domain(this.env.flatData.map(function (d) {
                return d.category
            }));

            var cntLines = 0;
            this.env.grpScale.range(this.env.flatData.map(function (d) {
                var pos = (cntLines + d.count / 2) / this.env.nLines * this.env.graphH;
                cntLines += d.count;
                return pos;
            }));

            this.env.svg.select('g.grp-axis')
                .transition()
                .duration(100)
                .style('font-size', fontSize + 'px')
                .call(this.env.grpAxis);

            groups.exit().transition().duration(500).style('stroke-opacity', 0).style('fill-opacity', 0).remove();

            var newGroups = groups.enter()
                .append('rect')
                .attr('class', 'series-group')
                .attr('x', 0)
                .attr('y', 0)
                .attr('height', 0)
                .style('fill', 'url(#grad)');

            newGroups.append('title').text('click-drag to pan or mouse wheel to zoom in/out');

            groups = groups.merge(newGroups);

            groups.transition().duration(500)
                .attr('width', this.env.graphW)
                .attr('height', function (d) { return this.env.graphH * d.count / this.env.nLines; })
                .attr('y', function (d) { return this.env.grpScale(d.category) - this.env.graphH * d.count / this.env.nLines / 2; })


        }
    },
    computed: {
        // d3() {
        //     return Object.assign({}, this.d3Base, this.d3Dag);
        // },
        
        nodeSizes() {
            const padding = 1.5;
            const base = this.nodeRadius * 2 * padding;
            const size = base;
                return [1.2 * size, size];
        },
     
        nodeGroups() { 
            return _.chain(this.nodeCapture).groupBy(data => data.x).map((value, key) => ({ x: key, items: value.map(item => item.data.id) })).value(); 
        },
        dataWithX() {
            return this.arrayData.map(data => {
                var match = this.nodeGroups.find(node => node.items.some(c => c === data.id)).x;
                data.line = match;
                return data;
            });
        },
        chart () {    
            //store unchanged data
            this.env.structData = this.dataWithX();

            //create d3 svg with viewing bounds
            const elem = this.d3.create("svg")
                .attr('class', 'timelines-chart')
                .attr("viewBox", [0, 0,1000, 1300])
                .style("overflow", "visible");

            //Set a much larger height and width for the internal svg
            this.env.svg = elem.append("svg")
                .attr("border", this.env.border)
                .attr("width", this.env.width)
                .attr("height", this.env.height);

            //perform initial zoom
            this.env.svg.call(this.zoom());

                var borderPath = this.env.svg.append("rect")
                            .attr("x", 0)
                            .attr("y", 0)
                            .attr("height", this.env.height)
                            .attr("width", this.env.width)
                            .style("fill", "none");
                    
                        var grad = this.env.svg.append('defs')
                            .append('linearGradient')
                            .attr('id', 'grad')
                            .attr('x1', '0%')
                            .attr('x2', '0%')
                            .attr('y1', '0%')
                            .attr('y2', '100%');

                        grad.selectAll('stop')
                            .data(this.env.groupBkgGradient)
                            .enter()
                            .append('stop')
                            .style('stop-color', function (d) { return d; })
                            .attr('offset', function (d, i) {
                                return 100 * (i / (this.env.groupBkgGradient.length - 1)) + '%';
                            })

            this.env.svg.transition().duration(100).attr('width', this.env.width).attr('height', this.env.height);

            this.env.graph = this.env.svg.append('g')

            this.env.g = this.env.svg.append("g").attr("transform", "translate(" + this.env.margin.left + "," + this.env.margin.top + ")");

            this.env.g.append('rect').attr("class", "temp")

            this.buildDomStructure();
            this.convertdata(dataWithX)
            this.parseData(this.env.structData);
            this.renderAxises();           
            this.draw();


            this.env.clip = this.env.svg.append("clipPath")
                .attr("id", "clip")
                .append("rect")
                .attr("width", this.env.graphW)
                .attr("height", 2200);
            
                return elem.node();
        }

    }
}
</script>
<style scoped>


  div#legend {
    font-size: 0.75rem;
    box-sizing: border-box;
    width: 13rem;
  }

  div#legend>div {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 2rem 10rem;
    column-gap: 0.5rem;
    margin-top: 1rem;
  }

  a { color: #3273dc; }


  div#ui { margin-bottom: 0; }

  div#vis-container {
    position: static;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
        height: 600px;
  }

  svg#svg-frame text {
    font-size: 10px;
    fill: #222;
  }

  svg text#svg-text-fontsize-placeholder {
    font-size: 10px;
  }

  .node rect {
    fill-opacity: 0.9;
    shape-rendering: crispEdges;
  }

  .node title text {
    pointer-events: none;
    text-shadow: 0 1px 0 #fff;
  }

  svg text.node-label {
     display: none; 
  }

  g.tick text { 
    text-anchor: start; 
    direction: ltr;
  }

  g.tick line {
    stroke: #999;
    stroke-width: 1.0px;
  }

  .link {
    stroke-opacity: .4;
  }

  .link:hover {
    stroke-opacity: .6;
  }

  div#vis-column {
    position: relative;
  }

  div#scroll-tip {
    display: inline;
    position: absolute;
    bottom: 460px;
    right: 1rem;
    opacity: 1;
    font-size: 4rem;
    color: rgba(50,115,220,1.0);
    height: 0;
  }
</style>